import { useEffect, useState } from "react";
import { _BudgetRPFactory } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Modal } from "../../theme/Component/Modal";
import { BasicButton } from "../../theme/Component/BasicButton";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { InputDate } from "../../theme/Input/InputDate";
import { AccountEditor } from "../../editor/AccountEditor";

interface Props {
    label?: string;
    _idAccount?: number;
    _date?: any;
    onChange: Function;
    currentVigency?: boolean;
}

export const RPsEditor = ({ label, onChange, _idAccount, _date, currentVigency }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_BudgetRPFactory);
    const single = Singleton.getInstance();

    const [valor, setValor] = useState<string>();
    const [idAccount, setIDAccount] = useState<number>(NaN);
    const [dateFrom, setDateFrom] = useState<any>(single.getCurrenDate());

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const getItem = () => {
        if (bean.IDDocument) {
            setModal({ ...modal, "view": false })
            setValor(`${bean.IDDocument} - ${bean.Mnemonic} - ${bean.Consecutive}`);
            onChange(bean)
        } else {
            toast.error("CDP no valido")
        }
    }

    const getCDPConsecutive = () => {

        instance.getRPDocuments(_idAccount ? _idAccount : idAccount, dateFrom).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: true, mask: MASK_NUMBER },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Valor del Registro Presupuestal', property: 'Value', visible: true },
        { title: 'Valor Obligado', property: 'OBValue', visible: true },
    ]

    return (
        <>

            <label>{label ?? "Registro Presupuestal"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    {!_idAccount &&
                        <div className="col-md-5">
                            <AccountEditor idAccount={idAccount} onChange={(e) => { setIDAccount(e.IDAccount) }} label="Beneficiario" />
                        </div>
                    }
                    <div className="col-md-5">
                        <InputDate _disable={_date ? true : false} name="" value={dateFrom} setDate={(e) => { setDateFrom(e) }} label="Fecha de Registro" />
                    </div>
                    <div className="col-md-2 mt-4">
                        <BasicButton eventClick={getCDPConsecutive} icon="ri-search-line">Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}